export const IN_PROCESS = 0
export const REJECTED = 1
export const NOT_VERIFIED = 2
export const VERIFIED = 3
export const VERIFIED_MESSAGE_SHOWN = 4
export const ASKED_VERIFICATION = 5
